import blockSpec from '@/lib/spec.js';

import api from '@/lib/api.js';
import schema from '@/lib/schema.js';

export default {
	async getBlocks(store) {
		let res = await api.blocks.getBlocks();
		if (!res) {
			//throw exception
			return false;
		}
		store.commit('SET_BLOCKS', res);
		return true;
	},

	/**
	 * Creates block
	 * Pass an object containing:
	 * @param {*} block : data for the new block. Make sure it contains parent id
	 * @returns new block
	 */
	// async createBlock(store, blockData) {
	// 	let mode = store.rootGetters['mode'];
	// 	let user = store.rootGetters['user/user'];

	// 	let parentBlock = store.getters['parentBlock'](blockData.block.parent);
	// 	blockData.block.blocks = blockData.block.blocks || [];
	// 	blockData.block.owner = blockData.block.owner || user._id;

	// 	blockData.block = blockSpec.createBlock(blockData.block);
	// 	let data = {
	// 		blockData: blockData,
	// 		parentBlock: parentBlock
	// 	};
	// 	let res = await api.blocks.transactionCreateBlock(data);
	// 	store.dispatch('marketing/checkEvents', {}, { root: true });
	// 	store.commit('ADD_BLOCK', res);
	// 	return res;
	// },

	/**
	 *
	 * @param {*} data.blocksArray -> array of blocks to be created
	 * @param {*} data.parentBlock -> parent block where the new blocks will be inserted
	 * @param {*} data.position -> position from where the new blocks will be inserted. Defaults to 0
	 * @param {*} data.undo -> If true, this action won't be pushed to the transaction undo queue
	 * @returns
	 */
	// async createBlocks(store, data) {
	// 	let user = store.rootGetters['user/user'];
	// 	let blocksArray = data.blocksArray;
	// 	let parentBlock = store.getters['parentBlock'](data.parentBlock._id);
	// 	let position = data.position || 0;

	// 	let blockIds = [];

	// 	for (let i = 0; i < blocksArray.length; i++) {
	// 		blocksArray[i] = blockSpec.createBlock(blocksArray[i], user._id);
	// 		blockIds.push(blocksArray[i]._id);
	// 		parentBlock.blocks.splice(position + i, 0, blocksArray[i]._id);
	// 	}

	// 	let payload = JSON.parse(JSON.stringify(data));

	// 	let obj = {
	// 		blocksArray: blocksArray,
	// 		parentBlock: parentBlock,
	// 		position: position
	// 	};
	// 	store.commit('ADD_BLOCKS', obj.blocksArray);
	// 	store.commit('UPDATE_BLOCK', obj.parentBlock);
	// 	// we're purposefully not awaiting this
	// 	api.blocks.transactionBulkAddBlocks(data);
	// 	if (!payload.undo) {
	// 		store.dispatch(
	// 			'transaction/add',
	// 			{
	// 				name: 'block/createBlocks',
	// 				payload: payload
	// 			},
	// 			{ root: true }
	// 		);
	// 	}
	// 	return obj.blocksArray;
	// },

	/**
	 * Removed array of blocks.
	 * Required all blocks to be removed to have the same parent
	 * @param {*} store
	 * @param {*} data -> blocksArray array of blocks containing blockids
	 * -> parentBlock -> block of the parent of these blockarrays
	 * @returns true
	 */
	async removeBlocksWrapper(store, data) {
		let blocksArray = data.blocksArray;
		let parentBlock = store.getters['parentBlock'](data.parentBlock._id);
		let blocks = store.state.blocks;
		let populatedBlocks = [];
		let oldParent = JSON.parse(JSON.stringify(parentBlock));

		if (typeof blocksArray[0] === 'object') {
			populatedBlocks = blocksArray;
		} else {
			for (let i = 0; i < blocks.length; i++) {
				if (blocksArray.includes(blocks[i]._id)) {
					populatedBlocks.push(blocks[i]);
				}
			}
		}
		data.blocksArray = populatedBlocks;
		let payload = JSON.parse(JSON.stringify(data));

		populatedBlocks = populatedBlocks.filter(block => {
			if (block.type === 'folder' && block.blocks.length > 0) {
				return false;
			}
			return true;
		});

		blocksArray = populatedBlocks.map(block => {
			return block._id;
		});

		for (let i = 0; i < blocksArray.length; i++) {
			let index = parentBlock.blocks.indexOf(blocksArray[i]);
			if (index !== -1) {
				parentBlock.blocks.splice(index, 1);
			}
		}

		store.dispatch('bulkDeleteBlocks', populatedBlocks);
		store.dispatch('updateBlock', parentBlock);

		// store.commit('DELETE_BLOCKS', blocksArray);
		// store.commit('UPDATE_BLOCK', parentBlock);

		// api.blocks.bulkRemoveBlocks(blocksArray);
		// api.blocks.updateBlock(parentBlock);

		store.dispatch(
			'transaction/add',
			[
				{
					name: 'block/bulkDeleteBlocks',
					payload: populatedBlocks
				},
				{
					name: 'block/updateBlock',
					payload: parentBlock
				}
			],
			{ root: true }
		);

		store.dispatch(
			'undo/add',
			[
				{
					name: 'block/bulkDeleteBlocks',
					payload: populatedBlocks
				},
				{
					name: 'block/updateBlock',
					payload: oldParent
				}
			],
			{ root: true }
		);
		return true;
	},

	// Basically, updateblock wrapper action
	async updatePosition(store, data) {
		let parentBlock = data.parentBlock;
		let currentBlock = data.currentBlock;
		let replacerBlock = data.replacerBlock;
		let position = data.position;

		let oldParentBlock = JSON.parse(JSON.stringify(data.parentBlock));

		let blocksArray = JSON.parse(JSON.stringify(parentBlock.blocks));

		let currentIndex = blocksArray.indexOf(currentBlock);
		let replacerIndex = blocksArray.indexOf(replacerBlock);

		// Current strat: move current block to new position around the replacer block
		// remove current block from array
		blocksArray.splice(currentIndex, 1);

		replacerIndex = blocksArray.indexOf(replacerBlock);
		if (position === 'bottom') {
			replacerIndex = replacerIndex + 1;
		}
		if (replacerIndex >= blocksArray.length - 1) {
			replacerIndex = blocksArray.length - 1;
		}
		blocksArray.splice(replacerIndex, 0, currentBlock);

		// swaps two array elements inside an array. May be useful in the future
		// blocksArray.splice(
		// 	replacerIndex,
		// 	1,
		// 	blocksArray.splice(currentIndex, 1, blocksArray[replacerIndex])[0]
		// );

		parentBlock.blocks = blocksArray;

		await store.dispatch('updateBlock', parentBlock);

		store.dispatch(
			'transaction/add',
			[
				{
					name: 'block/updateBlock',
					payload: parentBlock
				}
			],
			{ root: true }
		);

		store.dispatch(
			'undo/add',
			[
				{
					name: 'block/updateBlock',
					payload: oldParentBlock
				}
			],
			{ root: true }
		);

		return true;
	},

	/**
	 * This action is a bit funky, needs refactor
	 */
	async dropInBlock(store, data) {
		let parentBlock = data.parentBlock;
		let currentBlock = data.currentBlock;
		let replacerBlock = data.replacerBlock;
		replacerBlock = store.getters['block'](replacerBlock);

		console.log(parentBlock);

		if (replacerBlock.type !== 'folder' && replacerBlock.root !== true) {
			return true;
		}

		currentBlock = store.getters['block'](currentBlock);

		// Dont' allow drop if the current block already belongs inside the parent block where its supposed to be transferred
		if (currentBlock.parent !== parentBlock._id) {
			return true;
		}

		let oldCurrentBlock = JSON.parse(JSON.stringify(currentBlock));

		let oldParentBlock = JSON.parse(JSON.stringify(parentBlock));

		let oldReplacerBlock = JSON.parse(JSON.stringify(replacerBlock));

		currentBlock.parent = replacerBlock._id;

		replacerBlock.blocks.push(currentBlock._id);

		parentBlock.blocks = parentBlock.blocks.filter(blockId => {
			if (blockId === currentBlock._id) {
				return false;
			} else {
				return true;
			}
		});

		store.dispatch('updateBlock', currentBlock);

		store.dispatch('updateBlock', replacerBlock);

		store.dispatch('updateBlock', parentBlock);

		store.dispatch(
			'transaction/add',
			[
				{
					name: 'block/updateBlock',
					payload: currentBlock
				},
				{
					name: 'block/updateBlock',
					payload: replacerBlock
				},
				{
					name: 'block/updateBlock',
					payload: parentBlock
				}
			],
			{ root: true }
		);

		store.dispatch(
			'undo/add',
			[
				{
					name: 'block/updateBlock',
					payload: oldCurrentBlock
				},
				{
					name: 'block/updateBlock',
					payload: oldReplacerBlock
				},
				{
					name: 'block/updateBlock',
					payload: oldParentBlock
				}
			],
			{ root: true }
		);

		return true;
	},

	// This is a combo transaction
	async groupBlocks(store, data) {
		let blocksArray = data.blocksArray;
		let parentBlock = data.parentBlock;
		let blocks = store.state.blocks;
		let topIndex = 0;
		let newBlocks = [];

		let oldParentBlock = JSON.parse(JSON.stringify(parentBlock));

		// Populate blocksarray with actual blocks and thus create a newblocks array
		for (let i = 0; i < blocks.length; i++) {
			if (blocksArray.includes(blocks[i]._id)) {
				newBlocks.push(blocks[i]);
			}
		}

		let oldBlocks = JSON.parse(JSON.stringify(newBlocks));

		// remove array indices from the parentblock
		for (let i = 0; i < blocksArray.length; i++) {
			let index = parentBlock.blocks.indexOf(blocksArray[i]);
			if (index !== -1) {
				topIndex = index;
				parentBlock.blocks.splice(index, 1);
			}
		}

		let folderBlock = {
			blocks: [],
			content: {
				title: 'Notes'
			},
			source: {},
			blocks: blocksArray,
			parent: parentBlock._id,
			type: 'folder',
			root: false,
			archive: false
		};
		folderBlock = blockSpec.createBlock(folderBlock);

		parentBlock.blocks.splice(topIndex, 0, folderBlock._id);

		// create new block(folder block type)
		// folderBlock = await store.dispatch('createBlock', {
		// 	position: topIndex,
		// 	block: folderBlock
		// });

		// add the parent block id to the previously populated newblocks array
		for (let i = 0; i < newBlocks.length; i++) {
			newBlocks[i].parent = folderBlock._id;
		}

		// update all populated blocks
		//let update = await api.blocks.bulkUpdateBlocks(newBlocks);

		// update the parent block
		//await store.dispatch('updateBlock', parentBlock);

		store.dispatch('addBlock', folderBlock);
		store.dispatch('updateBlock', parentBlock);
		store.dispatch('bulkUpdateBlocks', newBlocks);

		store.dispatch(
			'transaction/add',
			[
				{
					name: 'block/addBlock',
					payload: folderBlock
				},
				{
					name: 'block/updateBlock',
					payload: parentBlock
				},
				{
					name: 'block/bulkUpdateBlocks',
					payload: newBlocks
				}
			],
			{ root: true }
		);

		store.dispatch(
			'undo/add',
			[
				{
					name: 'block/addBlock',
					payload: folderBlock
				},
				{
					name: 'block/updateBlock',
					payload: oldParentBlock
				},
				{
					name: 'block/bulkUpdateBlocks',
					payload: oldBlocks
				}
			],
			{ root: true }
		);

		return true;
	},

	// doesn't change state, used to copy block data to clipboard
	async copyBlocks(store, blocksArray) {
		if (!blocksArray) {
			return;
		}
		if (blocksArray.length < 1) {
			return;
		}

		let blocks = store.state.blocks;

		let populatedBlocks = [];

		let recursion = (function() {
			function populateBlocks(blocksArray) {
				let populatedBlocks = [];
				for (let i = 0; i < blocks.length; i++) {
					if (blocksArray.includes(blocks[i]._id)) {
						populatedBlocks.push(blocks[i]);
					}
				}
				return populatedBlocks;
			}

			function recursiveExpand(blocksArray) {
				blocksArray = populateBlocks(blocksArray);
				let newBlocks = [];
				for (let i = 0; i < blocksArray.length; i++) {
					newBlocks.push(blocksArray[i]);
					if (blocksArray[i].blocks.length > 0) {
						newBlocks = newBlocks.concat(
							recursiveExpand(blocksArray[i].blocks)
						);
					}
				}
				return newBlocks;
			}

			return recursiveExpand;
		})();

		for (let i = 0; i < blocksArray.length; i++) {
			let block = null;
			for (let j = 0; i < blocks.length; j++) {
				if (blocks[j]._id === blocksArray[i]) {
					block = blocks[j];
					break;
				}
			}
			populatedBlocks.push(block);
			if (block.blocks.length > 0) {
				let temp = recursion(block.blocks);
				populatedBlocks = populatedBlocks.concat(temp);
			}
		}

		let str = '';

		for (let i = 0; i < populatedBlocks.length; i++) {
			str += schema.blocks[populatedBlocks[i].type].copy(populatedBlocks[i]);
		}

		let result = await navigator.clipboard.writeText(str);
		store.dispatch('message/onCopy', {}, { root: true });
	}
};
